<div class="modal-header">
    <h4 class="modal-title">Kontaktirajte Kmetijo</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
  </div>
  <div class="modal-body">
    <form #contactForm="ngForm">
      <div class="mb-3">
        <label for="message" class="form-label">Sporočilo</label>
        <textarea class="form-control" id="message" [(ngModel)]="customerInfo.message" name="message" required></textarea>
      </div>
    </form>
    <h6 class="modal-subtitle">Naslovnik bo prejel vaše kontaktne podatke!</h6>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cancel()">Prekliči</button>
    <button type="button" class="btn btn-primary" (click)="sendMessage()">Pošlji</button>
  </div>